import ChangeRoleModal from './ChangeRoleModal/ChangeRoleModal'
import HandleBlockModal from './HandleBlockModal/HandleBlockModal'
import ChangeEmailModal from './ChangeEmailModal/ChangeEmailModal'
import ChangePasswordModal from './ChangePasswordModal'
import BuyPackageModal from './BuyPackageModal/BuyPackageModal'
import BlockReasonModal from './BlockReasonModal/BlockReasonModal'
import RemoveRequestModal from './RemoveRequestModal/RemoveRequestModal'
import GeneralInfo from './GeneralInfo/GeneralInfo'
import OperatorGeneralInfo from './OperatorGeneralInfo/OperatorGeneralInfo'
import AdminGeneralInfo from './AdminGeneralInfo/AdminGeneralInfo'
import SuperAdminGeneralInfo from './SuperAdminGeneralInfo/SuperAdminGeneralInfo'
import PersonalAccount from './PersonalAccount/PersonalAccount'
import PaymentAccount from './PaymentAccount/PaymentAccount'
import ESignatureModal from './ESignatureModal/ESignatureModal'
import DocumentsGrid from './DocumentsGrid/DocumentsGrid'
import FilterActivated from './FilterActivated/FilterActivated'
import FilterSubmitted from './FilterSubmitted/FilterSubmitted'
import GeneratorCard from './GeneratorCard/GeneratorCard'
import GeneratorCardFiled, { getStatus } from './GeneratorCard/GeneratorCardFiled'
import { AttorneyBlock } from '../../ui'

export {
    ChangeRoleModal,
    GeneralInfo,
    OperatorGeneralInfo,
    AdminGeneralInfo,
    SuperAdminGeneralInfo,
    PersonalAccount,
    PaymentAccount,
    ChangeEmailModal,
    ChangePasswordModal,
    RemoveRequestModal,
    ESignatureModal,
    DocumentsGrid,
    FilterActivated,
    FilterSubmitted,
    GeneratorCard,
    GeneratorCardFiled,
    getStatus,
    HandleBlockModal,
    BlockReasonModal,
    BuyPackageModal,
    AttorneyBlock,
}
